import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';
import { Markup } from 'interweave';
import { ActionsLockClosedNormalXsmall } from '@strava/icons';
import { color as colorToken } from '@strava/ui-tokens/js';
import { useActivityPublicContext } from '../../ActivityPublicContext';

import styles from './styles.scss';

const TYPES = {
  RIDE: 'ride',
  RUN: 'run'
};

const UpsellCTA = ({ children, type }) => {
  const { openSignUpModal, track } = useActivityPublicContext();
  const trackClick = () => {
    track({ element: `sign_up_${type}`, action: 'click' });
  };

  return (
    // deliberately not using @strava/ui/Button here for styling reasons
    <button
      type="button"
      onClick={() => {
        trackClick();
        openSignUpModal('generic');
      }}
      data-cy="upsell-cta"
    >
      {children}
    </button>
  );
};

UpsellCTA.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.string.isRequired
};

const Upsell = ({ type: _type }) => {
  const type = _type.toLowerCase();
  if (!Object.values(TYPES).includes(type)) {
    return null;
  }

  return (
    <div className={styles.upsellContainer}>
      <h3>
        {I18n.t(
          `strava.activities.show_public.${
            type === TYPES.RIDE ? 'segments' : 'splits'
          }`
        )}
      </h3>
      <div className={`${styles.upsellWrapper} ${styles[type]}`}>
        <div className={styles.content}>
          <UpsellCTA type={type}>
            <ActionsLockClosedNormalXsmall
              fill={colorToken.colorExtendedNeutralN3}
            />
            <Markup
              noWrap={true}
              content={I18n.t('strava.activities.show_public.signup_html')}
            />
          </UpsellCTA>
        </div>
      </div>
    </div>
  );
};

Upsell.propTypes = {
  type: PropTypes.string.isRequired
};

export default Upsell;
